<div class="modal-container">
  <div class="modal-title">Reschedule interview</div>

  <!-- Current interview info -->
  <div class="current-info-card">
    <div class="candidate-row">
      <div class="candidate-avatar">{{ getInitials(candidateName) }}</div>
      <div>
        <div class="candidate-name">{{ candidateName }}</div>
      </div>
    </div>
    <div class="current-time-row">
      <span class="info-icon">📅</span>
      {{ currentDateLabel }}
      <span class="info-icon" style="margin-left: 0.75rem;">🕐</span>
      {{ currentTimeLabel }}
    </div>
  </div>

  <!-- Title -->
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Interview title</mat-label>
    <input matInput [(ngModel)]="title" placeholder="e.g. Technical Manager interview">
  </mat-form-field>

  <!-- Date -->
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Select date</mat-label>
    <input matInput [matDatepicker]="picker" [(ngModel)]="selectedDate" [min]="minDate" readonly>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>

  <!-- Time row -->
  <div class="time-row">
    <mat-form-field appearance="outline" class="time-field">
      <mat-label>Start time</mat-label>
      <input matInput type="time" [(ngModel)]="startTime">
    </mat-form-field>
    <mat-form-field appearance="outline" class="time-field">
      <mat-label>End time</mat-label>
      <input matInput type="time" [(ngModel)]="endTime">
    </mat-form-field>
  </div>
  <mat-error *ngIf="startTime && endTime && !isTimeRangeValid()" style="font-size: 0.75rem; margin-bottom: 0.5rem;">
    Start time must be before end time.
  </mat-error>

  <!-- Guest invite section -->
  <div class="guests-section">
    <div class="guests-header">
      <div class="guests-title">Invite guests <span class="optional">(optional)</span></div>
      <div class="guests-subtitle">Invite guests to join the interview.</div>
    </div>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Full Name</mat-label>
      <input matInput [(ngModel)]="guestName" placeholder="Enter guest name">
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Email address</mat-label>
      <input matInput [(ngModel)]="guestEmail" placeholder="Email address" type="email">
    </mat-form-field>

    <app-button
      [label]="'+ Invite now'"
      [isFullWidth]="true"
      [size]="ButtonSize.LARGE"
      [state]="(guestName && isValidEmail(guestEmail)) ? ButtonState.REGULAR : ButtonState.DISABLED"
      [type]="ButtonType.SECONDARY"
      (click)="addGuest()">
    </app-button>
  </div>

  <!-- Invited guests list -->
  <div *ngIf="invitedGuests.length > 0" class="invited-guests">
    <div class="invited-label">Invited guests ({{ invitedGuests.length }})</div>
    <div class="guest-chips">
      <div *ngFor="let guest of invitedGuests; let i = index" class="guest-chip">
        <div class="chip-avatar">{{ getInitials(guest.guestName) }}</div>
        <span class="chip-name">{{ guest.guestName }}</span>
        <button class="chip-remove" (click)="removeGuest(i)">×</button>
      </div>
    </div>
  </div>

  <!-- Actions -->
  <div class="actions">
    <app-button
      label="Cancel"
      [size]="ButtonSize.LARGE"
      [state]="ButtonState.REGULAR"
      [type]="ButtonType.GHOST"
      (click)="cancel()">
    </app-button>
    <app-button
      label="Ask to reschedule"
      [size]="ButtonSize.LARGE"
      [state]="isFormValid ? ButtonState.REGULAR : ButtonState.DISABLED"
      [type]="ButtonType.PRIMARY"
      (click)="confirm()">
    </app-button>
  </div>
</div>
